import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "utils";

export const addPremiseAssignment = createAsyncThunk('premise_assignment/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'premise_assignment',
            data: {
                user_id: data?.values?.user_id,
                role_id: data?.values?.role_id,
                premise_id: data?.values?.premise_id,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updatePremiseAssignment = createAsyncThunk('premise_assignment/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'premise_assignment',
            data: {
                user_id: data?.values?.user_id,
                role_id: data?.values?.role_id,
                premise_id: data?.values?.premise_id,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delPremiseAssignment = createAsyncThunk('premise_assignment/delete', async ({ id }) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `premise_assignment/${id}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const premiseAssignment = createSlice({
    name: 'premiseAssignment',
    initialState: {
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addPremiseAssignment.pending, (state) => { state.loading = true })
            .addCase(addPremiseAssignment.fulfilled, (state) => { state.loading = false })
            .addCase(addPremiseAssignment.rejected, (state) => { state.loading = false })
            .addCase(updatePremiseAssignment.pending, (state) => { state.loading = true })
            .addCase(updatePremiseAssignment.fulfilled, (state) => { state.loading = false })
            .addCase(updatePremiseAssignment.rejected, (state) => { state.loading = false })
            .addCase(delPremiseAssignment.pending, (state) => { state.loading = true })
            .addCase(delPremiseAssignment.fulfilled, (state) => { state.loading = false })
            .addCase(delPremiseAssignment.rejected, (state) => { state.loading = false })
    },
})

export default premiseAssignment.reducer;
